const appleBuds = [
  {
    "title": "AirPods (1st Generation)",
    "landingPage": "https://cforcover.com/collections/airpods-1st-generation",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/AirPods_1st_Generation.avif?v=1759646021"
  },
  {
    "title": "AirPods (2nd Generation)",
    "landingPage": "https://cforcover.com/collections/airpods-2nd-generation",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/AirPods_2nd_Generation.avif?v=1759646021"
  },
  {
    "title": "AirPods (3rd Generation)",
    "landingPage": "https://cforcover.com/collections/airpods-3rd-generation",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/AirPods_3rd_Generation.avif?v=1759646021"
  },
  {
    "title": "AirPods (4th Generation)",
    "landingPage": "https://cforcover.com/collections/airpods-4th-generation",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/AirPods_4th_Generation.avif?v=1759646021"
  },
  {
    "title": "AirPods Pro (1st Generation)",
    "landingPage": "https://cforcover.com/collections/airpods-pro-1st-generation",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/AirPods_Pro_1st_Generation.webp?v=1759646021"
  },
  {
    "title": "AirPods Pro (2nd Generation)",
    "landingPage": "https://cforcover.com/collections/airpods-pro-2nd-generation",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/AirPods_Pro_2nd_Generation.webp?v=1759646022"
  },
  {
    "title": "AirPods Pro 2",
    "landingPage": "https://cforcover.com/collections/airpods-pro-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/AirPods_Pro_2.webp?v=1759646021"
  },
  {
    "title": "AirPods Pro 3",
    "landingPage": "https://cforcover.com/collections/airpods-pro-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/AirPods_Pro_3.jpg?v=1759646021"
  },
  {
    "title": "AirPods 4",
    "landingPage": "https://cforcover.com/collections/airpods-4",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/AirPods_4.webp?v=1759646021"
  }
]

const samsungBuds =  [
  {
    "title": "Galaxy Buds FE",
    "landingPage": "https://cforcover.com/collections/galaxy-buds-fe",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Galaxy_Buds_FE.jpg?v=1759646482"
  },
  {
    "title": "Galaxy Buds3 FE",
    "landingPage": "https://cforcover.com/collections/galaxy-buds3-fe",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Galaxy_Buds_3_FE.avif?v=1759646394"
  },
  {
    "title": "Galaxy Buds3 Pro",
    "landingPage": "https://cforcover.com/collections/galaxy-buds3-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Galaxy_Buds_3_Pro.avif?v=1759646394"
  },
  {
    "title": "Galaxy Buds3",
    "landingPage": "https://cforcover.com/collections/galaxy-buds3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Galaxy_Buds_3.avif?v=1759646395"
  },
  {
    "title": "Galaxy Buds2 Pro",
    "landingPage": "https://cforcover.com/collections/galaxy-buds2-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Galaxy_Buds2_Pro.avif?v=1759646395"
  },
  {
    "title": "Galaxy Buds2",
    "landingPage": "https://cforcover.com/collections/galaxy-buds2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Galaxy_Buds2.avif?v=1759646395"
  },
  {
    "title": "Galaxy Buds Live",
    "landingPage": "https://cforcover.com/collections/galaxy-buds-live-1",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Galaxy_Buds_Live.avif?v=1759646394"
  }
]

const boatBuds = [
  {
    "title": "boAt Airdopes 111v2",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-111v2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_111v2.webp?v=1759655523"
  },
  {
    "title": "boAt Airdopes 113",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-113",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_113.webp?v=1759655520"
  },
  {
    "title": "boAt Airdopes 121 Pro",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-121-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_121_Pro.webp?v=1759655522"
  },
  {
    "title": "boAt Airdopes 121 Pro Plus",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-121-pro-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_121_Pro_Plus.webp?v=1759655521"
  },
  {
    "title": "boAt Airdopes 131",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-131138",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_131.webp?v=1759655521"
  },
  {
    "title": "boAt Airdopes 131 Elite ANC",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-131-elite-anc",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_131_Elite_ANC.webp?v=1759655520"
  },
  {
    "title": "boAt Airdopes 131 Gen 2",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-131-gen-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_131_Gen_2.webp?v=1759655520"
  },
  {
    "title": "boAt Airdopes 131 Pro",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-131-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_131_PRO.webp?v=1759655521"
  },
  {
    "title": "boAt Airdopes 131 Pro Buds",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-131-pro-buds",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_131_Pro_Buds.webp?v=1759655522"
  },
  {
    "title": "boAt Airdopes 138",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-138",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_138.webp?v=1759655520"
  },
  {
    "title": "boAt Airdopes 138 Pro",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-138-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_138_Pro.webp?v=1759655522"
  },
  {
    "title": "boAt Airdopes 141",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-141",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_141.webp?v=1759655521"
  },
  {
    "title": "boAt Airdopes 141 ANC",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-141-anc",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_141_ANC.webp?v=1759655520"
  },
  {
    "title": "boAt Airdopes 141 Elite ANC",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-141-elite-anc",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_141_Elite_ANC.webp?v=1759655521"
  },
  {
    "title": "boAt Airdopes 141 Gen 2",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-141-gen-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_141_Gen_2.webp?v=1759655520"
  },
  {
    "title": "boAt Airdopes 141 Neo",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-141-neo",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_141_Neo.webp?v=1759655523"
  },
  {
    "title": "boAt Airdopes 141 Pro",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-141-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_141_Pro.webp?v=1759655520"
  },
  {
    "title": "boAt Airdopes 141 Pro Buds",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-141-pro-buds",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_141_Pro_Buds.webp?v=1759655520"
  },
  {
    "title": "boAt Airdopes 155",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-155",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_155.webp?v=1759655521"
  },
  {
    "title": "boAt Airdopes 163",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-163",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_163.webp?v=1759655519"
  },
  {
    "title": "boAt Airdopes 170",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-170",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_170.webp?v=1759655521"
  },
  {
    "title": "boAt Airdopes 191 ANC",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-191-anc",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_191_ANC.webp?v=1759655521"
  },
  {
    "title": "boAt Airdopes 192",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-192",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_192.webp?v=1759655522"
  },
  {
    "title": "boAt Airdopes 207",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-207",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_207.webp?v=1759655522"
  },
  {
    "title": "boAt Airdopes 212",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-212",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_212.webp?v=1759655520"
  },
  {
    "title": "boAt Airdopes 213",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-213",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_213.webp?v=1759655519"
  },
  {
    "title": "boAt Airdopes 219",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-219",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_219.jpg?v=1759655523"
  },
  {
    "title": "boAt Airdopes 300",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-300",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_300.webp?v=1759655521"
  },
  {
    "title": "boAt Airdopes 411 ANC",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-411-anc",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_411_ANC.webp?v=1759655520"
  },
  {
    "title": "boAt Airdopes 501 ANC",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-501-anc",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_501_ANC.webp?v=1759655521"
  },
  {
    "title": "boAt Airdopes 800",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-800",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_800.webp?v=1759655524"
  },
  {
    "title": "boAt Airdopes Ace",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-ace",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_Ace.webp?v=1759655522"
  },
  {
    "title": "boAt Airdopes Atom 81",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-atom-81",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_Atom_81.webp?v=1759655524"
  },
  {
    "title": "boAt Airdopes Bliss ANC",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-bliss-anc",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_Bliss_ANC.webp?v=1759655522"
  },
  {
    "title": "boAt Airdopes Drift",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-drift",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_Drift.webp?v=1759655524"
  },
  {
    "title": "boAt Airdopes Flex 454 ANC",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-flex-454-anc",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_Flex_454_ANC.webp?v=1759655521"
  },
  {
    "title": "boAt Airdopes Max",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-max",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_Max.webp?v=1759655520"
  },
  {
    "title": "boAt Airdopes Plus 311",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-plus-311",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_Plus_311.webp?v=1759655521"
  },
  {
    "title": "boAt Airdopes Plus 318",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-plus-318",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_Plus_318.webp?v=1759655524"
  },
  {
    "title": "boAt Airdopes Prime 701 ANC",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-prime-701-anc",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_Prime_701_ANC.webp?v=1759655522"
  },
  {
    "title": "boAt Airdopes Primo",
    "landingPage": "https://cforcover.com/collections/boat-airdopes-primo",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Airdopes_Primo.webp?v=1759655520"
  },
  {
    "title": "boAt Immortal 161",
    "landingPage": "https://cforcover.com/collections/boat-immortal-161",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Immortal_161.webp?v=1759655521"
  },
  {
    "title": "boAt Immortal Airspeed Pro",
    "landingPage": "https://cforcover.com/collections/boat-immortal-airspeed-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Immortal_Airspeed_Pro.webp?v=1759655524"
  },
  {
    "title": "boAt Nirvana Ion",
    "landingPage": "https://cforcover.com/collections/boat-nirvana-ion",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Nirvana_Ion.webp?v=1759655522"
  },
  {
    "title": "boAt Nirvana Ivy Pro",
    "landingPage": "https://cforcover.com/collections/boat-nirvana-ivy-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Nirvana_Ivy_Pro.webp?v=1759655520"
  },
  {
    "title": "boAt Nirvana Nebula",
    "landingPage": "https://cforcover.com/collections/boat-nirvana-nebula",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Nirvana_Nebula.webp?v=1759655520"
  },
  {
    "title": "boAt Nirvana Zenith Pro",
    "landingPage": "https://cforcover.com/collections/boat-nirvana-zenith-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/boAt_Nirvana_Zenith_Pro.webp?v=1759655522"
  }
]

const onePlusBuds =  [
  {
    "title": "OnePlus Nord Buds 3R",
    "landingPage": "https://cforcover.com/collections/oneplus-nord-buds-3r",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Nord_Buds_3R.png?v=1759656958"
  },
  {
    "title": "OnePlus Nord Buds 3 Pro",
    "landingPage": "https://cforcover.com/collections/oneplus-nord-buds-3-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Nord_Buds_3_Pro.webp?v=1759656957"
  },
  {
    "title": "OnePlus Nord Buds 3",
    "landingPage": "https://cforcover.com/collections/oneplus-nord-buds-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Nord_Buds_3.webp?v=1759656958"
  },
  {
    "title": "OnePlus Nord Buds 2R",
    "landingPage": "https://cforcover.com/collections/oneplus-nord-buds-2r",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Nord_Buds_2R.webp?v=1759656956"
  },
  {
    "title": "OnePlus Nord Buds 2",
    "landingPage": "https://cforcover.com/collections/oneplus-nord-buds-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Nord_Buds_2.webp?v=1759656958"
  },
  {
    "title": "OnePlus Nord Buds CE",
    "landingPage": "https://cforcover.com/collections/oneplus-nord-buds-ce",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Nord_Buds_CE.jpg?v=1759656957"
  },
  {
    "title": "OnePlus Nord Buds",
    "landingPage": "https://cforcover.com/collections/oneplus-nord-buds",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Nord_Buds.jpg?v=1759656957"
  },
  {
    "title": "OnePlus Buds 4",
    "landingPage": "https://cforcover.com/collections/oneplus-buds-4",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Buds_4.webp?v=1759656958"
  },
  {
    "title": "OnePlus Buds 3",
    "landingPage": "https://cforcover.com/collections/oneplus-buds-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Buds_3.png?v=1759656958"
  },
  {
    "title": "OnePlus Buds Pro 3",
    "landingPage": "https://cforcover.com/collections/oneplus-buds-pro-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Buds_Pro_3.jpg?v=1759656958"
  },
  {
    "title": "OnePlus Buds Pro 2",
    "landingPage": "https://cforcover.com/collections/oneplus-buds-pro-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Buds_Pro_2.jpg?v=1759656957"
  },
  {
    "title": "OnePlus Buds Pro (1st Gen)",
    "landingPage": "https://cforcover.com/collections/oneplus-buds-pro-1st-gen",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Buds_Pro_1st_Gen.png?v=1759656958"
  },
  {
    "title": "OnePlus Buds Z2",
    "landingPage": "https://cforcover.com/collections/oneplus-buds-z2-1",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Buds_Z2.jpg?v=1759656957"
  },
  {
    "title": "OnePlus Buds Z",
    "landingPage": "https://cforcover.com/collections/oneplus-buds-z",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Buds_Z.jpg?v=1759656957"
  },
  {
    "title": "OnePlus Buds",
    "landingPage": "https://cforcover.com/collections/oneplus-buds",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Buds.jpg?v=1759656956"
  }
]

const oppoBuds =[
  {
    "title": "OPPO Enco Air2",
    "landingPage": "https://cforcover.com/collections/oppo-enco-air2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Enco_Air2.webp?v=1759657653"
  },
  {
    "title": "OPPO Enco Air2 Pro",
    "landingPage": "https://cforcover.com/collections/oppo-enco-air2-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Enco_Air2_Pro.jpg?v=1759657652"
  },
  {
    "title": "OPPO Enco Air3 Pro",
    "landingPage": "https://cforcover.com/collections/oppo-enco-air3-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Enco_Air3_Pro.jpg?v=1759657652"
  },
  {
    "title": "OPPO Enco Air4",
    "landingPage": "https://cforcover.com/collections/oppo-enco-air4",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Enco_Air4.png?v=1759657653"
  },
  {
    "title": "OPPO Enco Buds",
    "landingPage": "https://cforcover.com/collections/oppo-enco-buds",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Enco_Buds.jpg?v=1759657652"
  },
  {
    "title": "OPPO Enco Buds2",
    "landingPage": "https://cforcover.com/collections/oppo-enco-buds2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Enco_Buds2.webp?v=1759657652"
  },
  {
    "title": "OPPO Enco Buds2 Pro",
    "landingPage": "https://cforcover.com/collections/oppo-enco-buds2-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Enco_Buds2_Pro.webp?v=1759657652"
  },
  {
    "title": "OPPO Enco Buds3",
    "landingPage": "https://cforcover.com/collections/oppo-enco-buds3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Enco_Buds3.jpg?v=1759657652"
  },
  {
    "title": "OPPO Enco Buds3 Pro",
    "landingPage": "https://cforcover.com/collections/oppo-enco-buds3-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Enco_Buds3_Pro.webp?v=1759657652"
  },
  {
    "title": "OPPO Enco X",
    "landingPage": "https://cforcover.com/collections/oppo-enco-x",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Enco_X.png?v=1759657654"
  },
  {
    "title": "OPPO Enco X2",
    "landingPage": "https://cforcover.com/collections/oppo-enco-x2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Enco_X2_881e26ca-380d-4332-9230-83ace7ba4258.png?v=1759657654"
  },
  {
    "title": "OPPO Enco X3",
    "landingPage": "https://cforcover.com/collections/oppo-enco-x3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Enco_X3_2da52377-e147-409b-b607-294ad48c5030.png?v=1759657654"
  },
  {
    "title": "OPPO Enco X3i",
    "landingPage": "https://cforcover.com/collections/oppo-enco-x3i",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Enco_X3i.jpg?v=1759657653"
  }
]

const realmeBuds = [
  {
    "title": "Realme Buds T310",
    "landingPage": "https://cforcover.com/collections/realme-buds-t310",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Buds_T310.webp?v=1759658148"
  },
  {
    "title": "Realme Buds T300",
    "landingPage": "https://cforcover.com/collections/realme-buds-t300",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Buds_T300.webp?v=1759658148"
  },
  {
    "title": "Realme Buds T200",
    "landingPage": "https://cforcover.com/collections/realme-buds-t200",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Buds_T200.webp?v=1759658148"
  },
  {
    "title": "Realme Buds T200x",
    "landingPage": "https://cforcover.com/collections/realme-buds-t200x",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Buds_T200x.webp?v=1759658148"
  },
  {
    "title": "Realme Buds T200 Lite",
    "landingPage": "https://cforcover.com/collections/realme-buds-t200-lite",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Buds_T200_Lite.webp?v=1759658148"
  },
  {
    "title": "Realme Buds T110",
    "landingPage": "https://cforcover.com/collections/realme-buds-t110",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Buds_T110.webp?v=1759658148"
  },
  {
    "title": "Realme Buds T100 (TechLife)",
    "landingPage": "https://cforcover.com/collections/realme-buds-t100-techlife",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Buds_T100_TechLife.webp?v=1759658148"
  },
  {
    "title": "Realme Buds T01",
    "landingPage": "https://cforcover.com/collections/realme-buds-t01",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Buds_T01.webp?v=1759658148"
  },
  {
    "title": "Realme Buds Q2 Neo",
    "landingPage": "https://cforcover.com/collections/realme-buds-q2-neo",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Buds_Q2_Neo.jpg?v=1759658148"
  },
  {
    "title": "Realme Buds Q2",
    "landingPage": "https://cforcover.com/collections/realme-buds-q2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Buds_Q2.webp?v=1759658148"
  },
  {
    "title": "Realme Buds Air 7 Pro",
    "landingPage": "https://cforcover.com/collections/realme-buds-air-7-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Buds_Air_7_Pro.webp?v=1759658148"
  },
  {
    "title": "Realme Buds Air 7",
    "landingPage": "https://cforcover.com/collections/realme-buds-air-7",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Buds_Air_7.webp?v=1759658148"
  },
  {
    "title": "Realme Buds Air 6 Pro",
    "landingPage": "https://cforcover.com/collections/realme-buds-air-6-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Buds_Air_6_Pro.webp?v=1759658148"
  },
  {
    "title": "Realme Buds Air 5 Pro",
    "landingPage": "https://cforcover.com/collections/realme-buds-air-5-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Buds_Air_5_Pro.webp?v=1759658148"
  },
  {
    "title": "Realme Buds Air 5",
    "landingPage": "https://cforcover.com/collections/realme-buds-air-5",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Buds_Air_5.webp?v=1759658148"
  }
]

const noiseBuds = [
  {
    "title": "Noise Master Buds",
    "landingPage": "https://cforcover.com/collections/noise-master-buds",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Noise_Master_Buds.webp?v=1759658588"
  },
  {
    "title": "Noise Air Buds Pro 6",
    "landingPage": "https://cforcover.com/collections/noise-air-buds-pro-6",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Noise_Air_Buds_Pro_6.webp?v=1759658588"
  },
  {
    "title": "Noise Buds Marine",
    "landingPage": "https://cforcover.com/collections/noise-buds-marine",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Noise_Buds_Marine.webp?v=1759658588"
  },
  {
    "title": "Noise Buds VS601",
    "landingPage": "https://cforcover.com/collections/noise-buds-vs601",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Noise_Buds_VS601_V2.webp?v=1759658588"
  },
  {
    "title": "Noise Buds F1",
    "landingPage": "https://cforcover.com/collections/noise-buds-f1",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Noise_Buds_F1.webp?v=1759658588"
  },
  {
    "title": "Noise Buds Uno",
    "landingPage": "https://cforcover.com/collections/noise-buds-uno",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Noise_Buds_Uno.webp?v=1759658588"
  },
  {
    "title": "Noise Buds X Ultra",
    "landingPage": "https://cforcover.com/collections/noise-buds-x-ultra",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Noise_Buds_X_Ultra.webp?v=1759658588"
  },
  {
    "title": "Noise Buds X2",
    "landingPage": "https://cforcover.com/collections/noise-buds-x2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Noise_Buds_X2_576f8fdb-7fed-4588-a3c9-052d9fb66f0d.webp?v=1759658588"
  },
  {
    "title": "Noise Buds Trooper",
    "landingPage": "https://cforcover.com/collections/noise-buds-trooper",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Noise_Buds_Trooper.webp?v=1759658588"
  },
  {
    "title": "Noise Buds VS204",
    "landingPage": "https://cforcover.com/collections/noise-buds-vs204",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Noise_Buds_VS204.webp?v=1759658588"
  },
  {
    "title": "Noise Buds VS102 Neo",
    "landingPage": "https://cforcover.com/collections/noise-buds-vs102-neo",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Noise_Buds_VS102_Neo.webp?v=1759658588"
  },
  {
    "title": "Noise Buds VS102 Pro",
    "landingPage": "https://cforcover.com/collections/noise-buds-vs102-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Noise_Buds_VS102_Pro.webp?v=1759658588"
  },
  {
    "title": "Noise Buds N1",
    "landingPage": "https://cforcover.com/collections/noise-buds-n1",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Noise_Buds_N1.webp?v=1759658588"
  },
  {
    "title": "Noise Buds N1 Pro",
    "landingPage": "https://cforcover.com/collections/noise-buds-n1-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Noise_Buds_N1_Pro.webp?v=1759658588"
  }
]


document.addEventListener("DOMContentLoaded", function () {
  const budProducts = [
    ...appleBuds,
    ...samsungBuds,
    ...boatBuds,
    ...onePlusBuds,
    ...oppoBuds,
    ...realmeBuds,
    ...noiseBuds
  ];

  // ✅ Match HTML IDs & classes for Buds
  const globalSearchBuds = document.querySelector("#global-search-input-buds");
  const displayBudsContainer = document.querySelector(".display-models-globally-buds");

  // ✅ Display function for Buds
  const displayBudModel = (modelObject) => {
    // console.log("Displaying bud:", modelObject);

    const anchor = document.createElement("a");
    const outerDiv = document.createElement("div");
    const imageContainer = document.createElement("div");
    const image = document.createElement("img");
    const titleParagraph = document.createElement("p");

    anchor.href = modelObject.landingPage;
    anchor.target = "_blank";
    anchor.style.textDecoration = "none";

    outerDiv.className = "one-item";

    image.src = modelObject.imagePath;
    image.alt = modelObject.title;

    titleParagraph.textContent = modelObject.title;

    imageContainer.appendChild(image);
    outerDiv.appendChild(imageContainer);
    outerDiv.appendChild(titleParagraph);
    anchor.appendChild(outerDiv);

    displayBudsContainer.appendChild(anchor);
  };

  // ✅ Search function for Buds
  function searchBuds() {
    const searchValue = globalSearchBuds.value.trim().toLowerCase();
    // console.log("Search input:", searchValue);

    const searchResult = budProducts.filter((obj) =>
      obj.title.toLowerCase().includes(searchValue)
    );

    displayBudsContainer.innerHTML = ""; // Clear previous results

    if (searchResult.length > 0) {
      // console.log("Search results:", searchResult);
      searchResult.forEach((obj) => displayBudModel(obj));
      displayBudsContainer.style.display = "block";
    } else {
      displayBudsContainer.style.display = "none";
    }

    if (globalSearchBuds.value === "") {
      displayBudsContainer.innerHTML = "";
      displayBudsContainer.style.display = "none";
    }
  }

  // ✅ Hide on outside click
  document.addEventListener("click", (event) => {
    if (!displayBudsContainer.contains(event.target) && event.target !== globalSearchBuds) {
      displayBudsContainer.style.display = "none";
      globalSearchBuds.value = "";
    }
  });

  // ✅ Input listener
  globalSearchBuds.addEventListener("input", searchBuds);

  // ✅ Default state
  displayBudsContainer.style.display = "none";
});


